import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

export const useCreateBotVersion = () => {
    const intl = useIntl();
    const history = useHistory();

    const createNewVersion = useCallback((currentBot, currentBotId = null) => {
        const newVersionName = prompt(
            intl.formatMessage({
                id: 'bot.version.createNew.prompt',
                defaultMessage: 'Enter a name for the new version:'
            })
        );

        if (newVersionName && newVersionName.trim()) {
            // Build the versions array including the new version
            const existingVersions = currentBot.config?.versions || [currentBot.config?.version || "DEFAULT"];
            const updatedVersions = [...existingVersions];
            if (!updatedVersions.includes(newVersionName.trim())) {
                updatedVersions.push(newVersionName.trim());
            }

            // Create a template from the current bot with the new version name
            const templateBotData = {
                ...currentBot,
                config: {
                    ...currentBot.config,
                    version: newVersionName.trim(),
                    versionGroup: currentBot.config?.versionGroup,
                    versions: updatedVersions,
                    status: "DRAFT"
                }
            };

            // Remove the ID since we're creating a new bot
            delete templateBotData.id;

            // Store in session storage with a special key
            sessionStorage.setItem('newBotTemplate', JSON.stringify(templateBotData));

            // Clear any existing session data for the current bot if we have an ID
            if (currentBotId) {
                sessionStorage.removeItem(`botData_${currentBotId}`);
            }

            // Determine the current tab to maintain the same view
            const currentPath = history.location.pathname;
            let currentTab = '/information'; // Default tab

            if (currentPath.includes('/instructions')) {
                currentTab = '/instructions';
            } else if (currentPath.includes('/materials')) {
                currentTab = '/materials';
            } else if (currentPath.includes('/information')) {
                currentTab = '/information';
            }

            // Navigate to new bot page with the same tab
            history.push(`/support-bot/new${currentTab}`);

            return true; // Success
        }

        return false; // Cancelled
    }, [intl, history]);

    return { createNewVersion };
};